import React, { useContext, useState, useCallback, useEffect } from 'react';
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import quizInstanceAdminStatusContext from '../context/quizInstanceAdminStatusContext';
import QuizApi from '../QuizApi';

export default function QuizAdminLobby() {

  const ctx = useContext(quizInstanceAdminStatusContext);
	const [counter, setCounter] = useState(null);
	const [starting, setStarting] = useState(false);
	const [roomMode, setRoomMode] = useState(false);
	const [standingMode, setStandingMode] = useState(false);

	const isMusicQuiz = ctx.quizInfo.type === "Musicquiz";

	useEffect(() => {

		const eventName = "quizParticipantCounterUpdate";
		const eventHandler = msg => { setCounter(msg.counter || 0); };

		ctx.socket.on(eventName, eventHandler);

		return () => {
			ctx.socket.off(eventName, eventHandler);
		};

	}, [ctx]);

	const startQuiz = useCallback(() => {

		const fn = async () =>
		{
			if (!starting)
			{
				setStarting(true);
				await QuizApi.quizInstanceStart(ctx.quizInfo.id, isMusicQuiz && roomMode, ctx.isSuperUser && standingMode);
				setStarting(false);
			}
		};

		fn();

	}, [ctx, starting, roomMode, standingMode, isMusicQuiz]);

	let authInfo;
	switch(ctx.quizInfo.auth.type)
	{
		case "Passcode":
			authInfo = <h1>Kod: {ctx.quizInfo.auth.json.passcode}</h1>;
		break;
	}

	return (
		<div id="quizAdminLobby">
			<div className="d-flex justify-content-center align-items-center h-100">
				<div className="text-center">
					<span>Gå till... </span><br />
					<div className="d-inline overflow-hidden mt-1 px-2 quizUrlPill">
						<a target="_blank" rel="noreferrer" className="text-quizPrimaryBold" href={ctx.quizUrl}>{ctx.quizUrl}</a>
					</div>
					<div>{authInfo}</div>
					<span>...eller skanna QR-koden... </span>
					<div className="mt-4">
						{ctx.quizUrlQrCode && <div className="mt-4">
							<img style={{width: "250px"}} src={ctx.quizUrlQrCode} alt=""/>
						</div>}
					</div>
					{counter === null ? "" : 
						<div>
							<br/>
							{counter === 0 && <span>Ingen här ännu ...</span>}
							{counter > 0 && 
								<span>{counter} person{counter !== 1 ? "er" : ""} redo!</span>
							}
						</div>
					}
					{isMusicQuiz && (
						<div className="mt-3" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', borderRadius: '8px', padding: '8px 14px' }}>
							<input
								type="checkbox"
								id="roomModeToggle"
								checked={roomMode}
								onChange={e => setRoomMode(e.target.checked)}
							/>
							<label htmlFor="roomModeToggle" style={{ margin: 0, cursor: 'pointer', fontWeight: 600 }}>
								Samlat läge (musik spelas centralt)
							</label>
						</div>
					)}
					{ctx.isSuperUser && (
						<div className="mt-3" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', borderRadius: '8px', padding: '8px 14px' }}>
							<input
								type="checkbox"
								id="standingModeToggle"
								checked={standingMode}
								onChange={e => setStandingMode(e.target.checked)}
							/>
							<label htmlFor="standingModeToggle" style={{ margin: 0, cursor: 'pointer', fontWeight: 600 }}>
								Stående instans (samlar in svar utan tidsgräns)
							</label>
						</div>
					)}
					{starting && <Spinner className="mt-3" animation="border" /> }
					{!starting &&
						<div>
						<Button type="submit" className="mt-3" variant="quizPrimary" onClick={startQuiz}>
							Starta!
						</Button>
						</div>
					}
				</div>
			</div>
		</div>
	);
};